import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/card'
import type { digitalPersonSnapshotTypes } from '@/store/api/Person/Person.types'

import { EmptyStateCard, EmptyStateCardIcon } from './EmptyStateCard'
import { PersonaSnapshotCard } from './PersonaSnapshotCard'

interface DigitalPersonaSnapshotWidgetTypes {
  attributes?: digitalPersonSnapshotTypes
}

export const DigitalPersonaSnapshotWidget = ({
  attributes,
}: DigitalPersonaSnapshotWidgetTypes) => {
  const { t } = useTranslation()
  const personaSnapshotData = [
    {
      title: t('report.generalInfo.positiveAttributes'),
      text: attributes?.positiveAttributes,
      itemColor: 'bg-dynamicGreen',
    },
    {
      title: t('report.generalInfo.neutralAttributes'),
      text: attributes?.neutralAttributes,
      itemColor: 'bg-dynamicYellow',
    },
    {
      title: t('report.generalInfo.negativeAttributes'),
      text: attributes?.negativeAttributes,
      itemColor: 'bg-dynamicRed',
    },
  ]

  const hasData =
    attributes?.positiveAttributes && attributes?.positiveAttributes.length > 0

  return (
    <Card className="flex flex-col bg-baseColor p-4 rounded-2xl gap-4">
      <p className="text-neutralColor text-xl font-medium">
        {t('report.generalInfo.digitalPersonaSnapshot')}
      </p>
      {hasData ? (
        <div className="flex flex-col gap-5">
          {personaSnapshotData.map((attribute, index) => (
            <PersonaSnapshotCard
              title={attribute.title}
              text={attribute.text || []}
              itemColor={attribute.itemColor}
              key={index}
            />
          ))}
        </div>
      ) : (
        <EmptyStateCard
          title={t('report.generalInfo.digitalPersonaSnapshotEmpty')}
          icon={EmptyStateCardIcon.PERSON}
        />
      )}
    </Card>
  )
}
